import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PMSPermissionEnum } from '../../shared/enums/permission.enum';
import { PMSRouteEnum } from '../../shared/enums/route.enum';
import { permissionGuard } from '../../shared/guards/auth/permission.guard';
import { DepartmentStaffsComponent } from './department-staffs/department-staffs.component';
import { DepartmentListComponent } from './department/department-list/department-list.component';

import { UserManagementComponent } from './user-management.component';

import { RoleManagementComponent } from '../../shared/components/rbac/role-management/role-management.component';
import { UserComponent } from '../../shared/components/rbac/user/user.component';
import { ViewDepartmentComponent } from './view-department/view-department.component';

const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./user-management.component').then(
        (c) => UserManagementComponent,
      ),
    children: [
      {
        path: '',
        redirectTo: PMSRouteEnum.PMS_ADMIN,
        pathMatch: 'full',
      },
      {
        path: PMSRouteEnum.PMS_ADMIN,
        loadComponent: () =>
          import('../../shared/components/rbac/user/user.component').then(
            (c) => UserComponent,
          ),
        canActivate: [permissionGuard],
        data: {
          permission: [PMSPermissionEnum.PMS_USER_READ],
          creationType: 'admin',
        },
      },
      {
        path: PMSRouteEnum.PMS_STAFF,
        loadComponent: () =>
          import('../../shared/components/rbac/user/user.component').then(
            (c) => UserComponent,
          ),
        canActivate: [permissionGuard],
        data: {
          permission: [PMSPermissionEnum.PMS_PROPERTY_STAFFS_READ],
          creationType: 'staff',
        },
      },
      {
        path: PMSRouteEnum.PMS_DEPARTMENT,
        loadComponent: () =>
          import('./department/department-list/department-list.component').then(
            (c) => DepartmentListComponent,
          ),
        canActivate: [permissionGuard],
        data: {
          showAddDepartment: true,
          permission: [
            PMSPermissionEnum.PMS_DEPARTMENT,
            PMSPermissionEnum.PMS_DEPARTMENT_CREATE,
            PMSPermissionEnum.PMS_DEPARTMENT_READ,
          ],
        },
      },
      {
        path: PMSRouteEnum.PMS_DEPARTMENT_STAFFS,
        loadComponent: () =>
          import('./department-staffs/department-staffs.component').then(
            (c) => DepartmentStaffsComponent,
          ),
        canActivate: [permissionGuard],
        data: {
          permission: [
            PMSPermissionEnum.PMS_STAFF_CREATE,
            PMSPermissionEnum.PMS_STAFF_READ,
          ],
        },
      },
      {
        path: PMSRouteEnum.PMS_USER_ROLE,
        loadComponent: () =>
          import('../../shared/components/rbac/role-management/role-management.component').then(
            (c) => RoleManagementComponent,
          ),
        canActivate: [permissionGuard],
        data: {
          permission: [
            PMSPermissionEnum.PMS_ROLE,
            PMSPermissionEnum.PMS_ROLE_CREATE,
          ],
        },
      },
      {
        path: PMSRouteEnum.PMS_VIEW_DEPARTMENT,
        loadComponent: () =>
          import('./view-department/view-department.component').then(
            (c) => ViewDepartmentComponent,
          ),
        canActivate: [permissionGuard],
        data: {
          permission: [PMSPermissionEnum.PMS_DEPARTMENT_READ],
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserManagementRoutingModule {}
